import * as React from "react";
import { View, Text } from "react-native";

export type ErrorComponentProps = React.PropsWithChildren<{ error: unknown }>;

function ErrorComponent({ error }: ErrorComponentProps) {
  return (
    <View>
      <Text>Error: {(error as Error).toString}</Text>
    </View>
  );
}

export default ErrorComponent;
